/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable max-len */
import { useRef, forwardRef, useImperativeHandle, useState, useEffect, useMemo } from 'react';

import useStyles from './style';
import { Button, Grid, Typography } from '@material-ui/core';
import {
  dataHarmony,
  dataPreference,
  getFromLS,
  publicImgMajorTest,
  publicSvgPath,
  resultatWithColor,
} from '@orientaction/utils';
import dateFormat from 'dateformat';
import { getUserById } from '../../../../services/user.service';
import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import { concat, take } from 'lodash';
import { UserResultRadarGraph } from '@orientaction/components';
import { explanationParagraphs } from '../StudyStyle/Explanation/constant';
import constantSuggestion from '../StudyStyle/constantSuggestion';
import { explanationParagraphs as explanationParagraphsLoveMatter } from '../LoveMatter/Explanation/constant';
import constantSuggestionLoveMatter from '../LoveMatter/constantSuggestionLoveMatter';

export interface ResultatPDFHandle {
  handleDownload: () => Promise<void>;
}

const ResultatPDF = forwardRef<ResultatPDFHandle, { myResult: any; idResult?: number }>(
  ({ myResult, idResult }, ref) => {
    const classes = useStyles({});
    const headerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const chartContainerRef = useRef<HTMLDivElement>(null);
    const { users_permissions_user, loveMatter, studyStyle, listHistory } = myResult;
    const token = getFromLS('userToken') || '';
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [date, setDate] = useState<string>('');
    const [chartImage, setChartImage] = useState<string | null>(null);
    const lang: string = useSelector(appLanguage);

    useEffect(() => {
      const getUser = () => {
        setLoading(true);
        if (token && users_permissions_user) {
          getUserById({ token, userId: users_permissions_user })
            .then((res: any) => {
              setUser(res?.data ?? {});
              return 'ok';
            })
            .then(() => {
              setLoading(false);
            });
        }
      };
      getUser();
    }, [users_permissions_user, token]);

    // Convertir le canvas Chart.js en image
    useEffect(() => {
      if (!myResult || loading) return;

      const convertChartToImage = () => {
        // Attendre que le canvas soit rendu
        const checkCanvas = setInterval(() => {
          const canvas = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
          if (canvas && canvas.width > 0 && canvas.height > 0) {
            clearInterval(checkCanvas);
            try {
              // Convertir le canvas en image base64 avec haute qualité
              const imageData = canvas.toDataURL('image/png', 1.0);
              setChartImage(imageData);
            } catch (error) {
              // En cas d'erreur, on continue sans l'image
              // eslint-disable-next-line no-console
              console.error('Erreur lors de la conversion du canvas en image:', error);
            }
          }
        }, 200);

        // Timeout après 5 secondes pour éviter une boucle infinie
        setTimeout(() => {
          clearInterval(checkCanvas);
        }, 5000);
      };

      // Attendre que le graphique soit complètement rendu
      const timer = setTimeout(() => {
        convertChartToImage();
      }, 1500);

      return () => {
        clearTimeout(timer);
      };
    }, [myResult, loading]);

    const handleDownload = async () => {
      if (!headerRef.current || !contentRef.current) {
        return;
      }

      // S'assurer que l'image du graphique est générée avant l'export
      if (!chartImage) {
        const canvas = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
        if (canvas && canvas.width > 0 && canvas.height > 0) {
          try {
            const imageData = canvas.toDataURL('image/png', 1.0);
            setChartImage(imageData);
            // Attendre un peu pour que l'image soit mise à jour dans le DOM
            await new Promise(resolve => setTimeout(resolve, 300));
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Erreur lors de la conversion du canvas en image:', error);
          }
        } else {
          // Attendre que le canvas soit rendu
          await new Promise(resolve => setTimeout(resolve, 1000));
          const canvasRetry = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
          if (canvasRetry && canvasRetry.width > 0 && canvasRetry.height > 0) {
            try {
              const imageData = canvasRetry.toDataURL('image/png', 1.0);
              setChartImage(imageData);
              await new Promise(resolve => setTimeout(resolve, 300));
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error('Erreur lors de la conversion du canvas en image:', error);
            }
          }
        }
      }

      const { default: html2pdf } = await import('html2pdf.js');

      // Options pour le premier PDF (header sans margin)
      const headerOptions = {
        margin: [0, 0, 0, 0], // Pas de margin pour le header
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#FFF',
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Format A4 en pixels à ~150 DPI : 1240px × 1754px (210mm × 297mm)
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          after: '.page-break-after',
        },
      } as any;

      // Options pour le second PDF (contenu avec margin)
      const contentOptions = {
        margin: [80, 0, 80, 0], // Margin global pour le contenu
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#F7F7FB',
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Même format que le header pour garder un rendu homogène
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: '.page-break-before',
          after: '.page-break-after',
        },
      } as any;

      try {
        // Générer le premier PDF (header) en mémoire
        const headerPdfBlob = await html2pdf()
          .set(headerOptions)
          .from(headerRef.current)
          .output('blob');

        // Générer le second PDF (contenu) en mémoire
        const contentPdfBlob = await html2pdf()
          .set(contentOptions)
          .from(contentRef.current)
          .output('blob');

        // Convertir les blobs en ArrayBuffers
        const headerArrayBuffer = await headerPdfBlob.arrayBuffer();
        const contentArrayBuffer = await contentPdfBlob.arrayBuffer();

        // Utiliser pdf-lib pour fusionner les PDFs
        const { PDFDocument } = await import('pdf-lib');

        // Créer un nouveau document PDF
        const mergedPdf = await PDFDocument.create();

        // Charger les deux PDFs
        const headerPdfDoc = await PDFDocument.load(headerArrayBuffer);
        const contentPdfDoc = await PDFDocument.load(contentArrayBuffer);

        // Copier toutes les pages du header PDF
        const headerPages = await mergedPdf.copyPages(headerPdfDoc, headerPdfDoc.getPageIndices());
        headerPages.forEach((page: any) => mergedPdf.addPage(page));

        // Copier toutes les pages du content PDF
        const contentPages = await mergedPdf.copyPages(
          contentPdfDoc,
          contentPdfDoc.getPageIndices()
        );
        contentPages.forEach((page: any) => mergedPdf.addPage(page));

        // Sauvegarder le PDF fusionné
        const mergedPdfBytes = await mergedPdf.save();
        const uint8Array = new Uint8Array(mergedPdfBytes);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Résultat Study® test d'orientation - ${user?.firstname || ''} ${
          user?.lastname || ''
        }.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erreur lors de la génération du PDF:', error);
      }
    };

    useImperativeHandle(ref, () => ({
      handleDownload,
    }));

    const harmonyData: any = useMemo(() => {
      return dataHarmony(myResult);
    }, [myResult]);

    useEffect(() => {
      setDate(listHistory.find((item: any) => item.id === idResult)?.createdAt);
    }, [listHistory, idResult]);

    return (
      <>
        {!loading && myResult && (
          <div className={classes.wrapper}>
            {/* Premier export PDF - Header sans margin */}
            <div ref={headerRef} className={classes.page}>
              <div id="ma-banniere-pdf" className={`${classes.header}`}>
                <Typography variant="h2" className={classes.titleHeader} style={{ margin: 0 }}>
                  Study® - test d'orientation
                </Typography>
              </div>
              <div className="page-break-after" style={{ padding: '80px 80px 0px 80px' }}>
                <div className={classes.imgBanner}>
                  <img src={`${publicImgMajorTest}/study.png`} alt="couverture intro" />
                </div>
                <div className={classes.info}>
                  <div className={classes.infoContent}>
                    Nom du test : <span>Study® - test d'orientation</span>
                  </div>
                  <div className={classes.infoContent}>
                    Bénéficiaire :{' '}
                    <span>
                      {user?.firstname} {user?.lastname}
                    </span>
                  </div>
                  <div className={classes.infoContent}>
                    Date de passation :{' '}
                    <span>{date && dateFormat(new Date(date), 'dd/mm/yyyy')}</span>
                  </div>
                  <div className={classes.infoContent}>
                    Consultant :{' '}
                    <span>
                      {user?.upper_hierarchy?.firstname} {user?.upper_hierarchy?.lastname}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Second export PDF - Contenu avec margin */}
            <div ref={contentRef} className={classes.page}>
              <div style={{ padding: '0px 80px 0px 80px' }}>
                <div className={`${classes.section}`}>
                  <h2 className={`${classes.heading} ${classes.h1}`}>
                    Ton Study® Style est {studyStyle?.favorite?.label}
                  </h2>

                  <div className={classes.imgWhiteBanner}>
                    <img src={studyStyle?.favorite?.img} alt="" />
                  </div>

                  <h2 className={`${classes.heading} ${classes.h4}`}>
                    Ton profil correspond à{' '}
                    {Math.round((studyStyle?.treeMax[0]?.score * 100) / 1000)}% à un(e){' '}
                    {studyStyle?.treeMax[0]?.label}.
                  </h2>
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Ton score : {studyStyle?.treeMax[0]?.score} / 1000
                  </h2>
                  {explanationParagraphs[studyStyle?.treeMax[0]?.key].map(
                    (paragraph: string, index: number) => (
                      <p className={classes.paragraph} style={{ marginBottom: 0 }}>
                        {paragraph}
                      </p>
                    )
                  )}

                  <h2
                    className={`${classes.heading} ${classes.h2} page-break-before`}
                    style={{ marginTop: 30, marginBottom: 80 }}>
                    {constantSuggestion[studyStyle?.favorite?.key]?.text}
                  </h2>
                  {constantSuggestion[studyStyle?.favorite?.key]?.subtitle?.length > 0 &&
                    constantSuggestion[studyStyle?.favorite?.key]?.subtitle?.map(
                      (subtitle: string, index: number) => (
                        <p className={classes.paragraph} key={index}>
                          {subtitle}
                        </p>
                      )
                    )}
                  <ul className={classes.listUl}>
                    {constantSuggestion[studyStyle?.favorite?.key]?.list.map(
                      (item: string, index: number) => (
                        <li className={classes.listLi} key={index}>
                          {item}
                        </li>
                      )
                    )}
                  </ul>
                  {constantSuggestion[studyStyle?.favorite?.key]?.subtitle2?.length > 0 &&
                    constantSuggestion[studyStyle?.favorite?.key]?.subtitle2?.map(
                      (subtitle: string, index: number) => (
                        <p className={classes.paragraph} key={index}>
                          {subtitle}
                        </p>
                      )
                    )}

                  <p
                    className={classes.paragraph}
                    style={{ textAlign: 'center', marginTop: 120 }}
                    dangerouslySetInnerHTML={{
                      __html: constantSuggestion[studyStyle?.favorite?.key]?.citation,
                    }}
                  />
                  <h2
                    className={`${classes.heading} ${classes.h6}`}
                    style={{ textAlign: 'center', marginTop: 20 }}>
                    {constantSuggestion[studyStyle?.favorite?.key]?.author}
                  </h2>
                </div>
                <div className={`${classes.section} page-break-before`}>
                  <h2 className={`${classes.heading} ${classes.h1}`}>
                    Ta love matière ❤️ est {loveMatter?.favorite?.label}
                  </h2>

                  <div className={classes.imgWhiteBanner}>
                    <img src={loveMatter?.favorite?.img} alt="" />
                  </div>

                  <h2 className={`${classes.heading} ${classes.h4}`}>
                    Ton profil correspond à{' '}
                    {Math.round((loveMatter?.treeMax[0]?.score * 100) / 1200)}% à{' '}
                    {loveMatter?.treeMax[0]?.label}.
                  </h2>
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Ton score : {loveMatter?.treeMax[0]?.score} / 1200
                  </h2>
                  {explanationParagraphsLoveMatter[loveMatter?.treeMax[0]?.key].map(
                    (paragraph: string, index: number) => (
                      <p className={classes.paragraph} style={{ marginBottom: 0 }}>
                        {paragraph}
                      </p>
                    )
                  )}

                  <h2
                    className={`${classes.heading} ${classes.h2} page-break-before`}
                    style={{ marginTop: 30, marginBottom: 80 }}>
                    {constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.text}
                  </h2>
                  {constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.subtitle?.length > 0 &&
                    constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.subtitle?.map(
                      (subtitle: string, index: number) => (
                        <p className={classes.paragraph} key={index}>
                          {subtitle}
                        </p>
                      )
                    )}
                  <ul className={classes.listUl}>
                    {constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.list.map(
                      (item: string, index: number) => (
                        <li className={classes.listLi} key={index}>
                          {item}
                        </li>
                      )
                    )}
                  </ul>
                  {constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.subtitle2?.length > 0 &&
                    constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.subtitle2?.map(
                      (subtitle: string, index: number) => (
                        <p className={classes.paragraph} key={index}>
                          {subtitle}
                        </p>
                      )
                    )}

                  <p
                    className={classes.paragraph}
                    style={{ textAlign: 'center', marginTop: 120 }}
                    dangerouslySetInnerHTML={{
                      __html: constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.citation,
                    }}
                  />
                  <h2
                    className={`${classes.heading} ${classes.h6}`}
                    style={{ textAlign: 'center', marginTop: 20 }}>
                    {constantSuggestionLoveMatter[loveMatter?.favorite?.key]?.author}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
);

ResultatPDF.displayName = 'ResultatPDF';

export default ResultatPDF;
